"use client";

import React from "react";
import { ShieldCheck, Clock, ThumbsUp, Headset } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: ShieldCheck,
  label: "Tecnología Certificada"
}, {
  icon: Clock,
  label: "Soporte Inmediato"
}, {
  icon: ThumbsUp,
  label: "Garantía de Calidad"
}, {
  icon: Headset,
  label: "Atención 24/7"
}];
export default function Brandannouncement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}